var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import BaseService from './base';
import httpClient, { setAxiosGlobalHeaders, MW_BASE_BETA_URL, MW_BASE_DEV_URL, MW_BASE_LIVE_URL, MW_BASE_STAGING_URL, MW_BASE_SANDBOX_URL } from './httpClient';
import BrowserInfo from '@tap-payments/browser-info';
import { generateApplicationHeader, rsaSetup } from '../utils/config';
import { RSA_BETA_MW_PUBLIC_KEY, RSA_DEV_MW_PUBLIC_KEY, RSA_PRODUCTION_MW_PUBLIC_KEY, RSA_SANDBOX_MW_PUBLIC_KEY, RSA_STAGING_MW_PUBLIC_KEY } from '../constants';
var APPService = (function (_super) {
    __extends(APPService, _super);
    function APPService() {
        var _this = _super.call(this, httpClient) || this;
        Object.defineProperty(_this, "baseUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "env", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this.baseUrl = MW_BASE_LIVE_URL;
        _this.env = 'production';
        return _this;
    }
    Object.defineProperty(APPService.prototype, "setEnv", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (env) {
            this.env = env;
        }
    });
    Object.defineProperty(APPService.prototype, "setBaseUrl", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (!this.env)
                throw new Error('Environment is not set');
            switch (this.env) {
                case 'staging':
                    this.baseUrl = MW_BASE_STAGING_URL;
                    break;
                case 'beta':
                    this.baseUrl = MW_BASE_BETA_URL;
                    break;
                case 'development':
                    this.baseUrl = MW_BASE_DEV_URL;
                    break;
                case 'sandbox':
                    this.baseUrl = MW_BASE_SANDBOX_URL;
                    break;
                default:
                    this.baseUrl = MW_BASE_LIVE_URL;
                    break;
            }
        }
    });
    Object.defineProperty(APPService.prototype, "getHeaderPublicKey", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (!this.env)
                throw new Error('Environment is not set');
            switch (this.env) {
                case 'staging':
                    return RSA_STAGING_MW_PUBLIC_KEY;
                case 'beta':
                    return RSA_BETA_MW_PUBLIC_KEY;
                case 'development':
                    return RSA_DEV_MW_PUBLIC_KEY;
                case 'sandbox':
                    return RSA_SANDBOX_MW_PUBLIC_KEY;
                default:
                    return RSA_PRODUCTION_MW_PUBLIC_KEY;
            }
        }
    });
    Object.defineProperty(APPService.prototype, "setBrowserHeaders", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (_a) {
            var locale = _a.locale, pk = _a.pk, domain = _a.domain;
            return __awaiter(this, void 0, void 0, function () {
                var encryptString, encryptedHeaders, mdn, authorization, rest, application;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            encryptString = rsaSetup(this.getHeaderPublicKey());
                            return [4, new BrowserInfo.BrowserInfo({
                                    app: { name: '@tap-payments/apple-pay-button', language: locale },
                                    credentials: { mdn: domain, pk: pk },
                                    encrypt: function (_key, value) { return encryptString(value.substring(0, 115)); }
                                }).get()];
                        case 1:
                            encryptedHeaders = _b.sent();
                            mdn = encryptedHeaders.mdn, authorization = encryptedHeaders.authorization, rest = __rest(encryptedHeaders, ["mdn", "authorization"]);
                            application = generateApplicationHeader(rest);
                            setAxiosGlobalHeaders({
                                authorization: pk,
                                mdn: mdn,
                                application: application
                            });
                            return [2];
                    }
                });
            });
        }
    });
    Object.defineProperty(APPService.prototype, "checkoutProfile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (request) {
            return __awaiter(this, void 0, void 0, function () {
                var data, merchant, payment_options, session;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.post(this.baseUrl + '/checkoutprofile', request)];
                        case 1:
                            data = (_a.sent()).data;
                            if (data.errors)
                                throw data;
                            merchant = data.merchant, payment_options = data.payment_options, session = data.session;
                            setAxiosGlobalHeaders({ session: session });
                            return [2, { merchant: merchant, payment_options: payment_options }];
                    }
                });
            });
        }
    });
    Object.defineProperty(APPService.prototype, "appleSession", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (merchant, validationURL, merchantRegisteredDomain, merchantIdentifier) {
            return __awaiter(this, void 0, void 0, function () {
                var body, data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            body = {
                                validationUrl: validationURL,
                                origin: merchantRegisteredDomain,
                                merchantIdentifier: String(merchantIdentifier),
                                merchantId: String(merchant.id),
                                merchantName: merchant.name
                            };
                            return [4, this.post(this.baseUrl + '/validatemerchant', body)];
                        case 1:
                            data = (_a.sent()).data;
                            if (data.errors)
                                throw data;
                            return [2, data];
                    }
                });
            });
        }
    });
    Object.defineProperty(APPService.prototype, "tapTokenization", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (applePaymentData) {
            return __awaiter(this, void 0, void 0, function () {
                var body, data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            body = {
                                type: 'applepay',
                                token_data: applePaymentData
                            };
                            return [4, this.post(this.baseUrl + '/token', body)];
                        case 1:
                            data = (_a.sent()).data;
                            if (data.errors)
                                throw data;
                            return [2, data];
                    }
                });
            });
        }
    });
    return APPService;
}(BaseService));
var appService = new APPService();
export default appService;
